<template>
  <el-drawer
    title="订单详情"
    :visible.sync="isShowDrawer"
    :before-close="handleClose"
    :modal="false"
    close-on-click-modal
    size="45%"
  >
    <div class="order_details">
      <div class="form_box">
        <y-form
          ref="searchForm"
          :form-info="formInfo"
          @search="getSearch"
          @selfReset="getClean"
        >
          <template #channelSellerManageIdList>
            <el-select
              v-model="orderSearch.channelSellerManageIdList"
              multiple
              collapse-tags
              placeholder="请选择"
              style="width: 290px"
            >
              <el-option
                v-for="item in shopList"
                :key="item.channelSellerManageId"
                :label="item.shopTitle"
                :value="item.channelSellerManageId"
              >
              </el-option>
            </el-select>
          </template>
          <template #statusList>
            <el-select
              style="width: 290px"
              v-model="orderSearch.statusList"
              multiple
              collapse-tags
              placeholder="请选择"
            >
              <el-option
                v-for="item in orderStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template #tid>
            <el-input
              size="small"
              placeholder="请输入"
              style="width: 290px"
              clearable
              v-model="orderSearch.tid"
            ></el-input>
          </template>
        </y-form>
      </div>
      <div class="global-felx-1">
        <y-table
          :tableData="tableData"
          :tableInfo="tableInfo"
          tooltip-effect="dark"
          :loading="talbeLoading"
          :pageInfo="{
            pageNum: pageInfo.pageNum,
            pageSize: pageInfo.pageSize,
            total: totalList,
          }"
          @handlePage="handlePage"
        >
          <template #type="scope">
            <span>{{ getLabel(scope.row.type, typeOptions) }}</span>
          </template>
          <template #status="scope">
            <span>{{ getLabel(scope.row.status, orderStatus) }}</span>
          </template>
          <template #payType="scope">
            <span>{{ getLabel(scope.row.payType, payType) }}</span>
          </template>
          <template #isExpandCardAmount="scope">
            <span>{{
              Number(scope.row.expandCardAmount) != 0 ? "是" : "否"
            }}</span>
          </template>
        </y-table>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  isScoresBindList,
  getOrderListReq,
} from "@/api/integralCenter/newMemberSystem";
export default {
  data() {
    return {
      isShowDrawer: false,
      formInfo: [
        {
          label: "店铺：",
          prop: "channelSellerManageIdList",
          slot: "channelSellerManageIdList",
        },
        {
          label: "交易状态：",
          prop: "statusList",
          slot: "statusList",
        },
        {
          label: "订单号：",
          prop: "tid",
          slot: "tid",
        },
      ],
      orderStatus: [
        {
          label: "待付款",
          value: "0",
        },
        {
          label: "国际信用卡支付付款确认中",
          value: "1",
        },
        {
          label: "0元购合约中",
          value: "2",
        },
        {
          label: "等待发货",
          value: "3",
        },
        {
          label: "部分发货",
          value: "4",
        },
        {
          label: "等待确认收货",
          value: "5",
        },
        {
          label: "完成",
          value: "6",
        },
        {
          label: "已关闭",
          value: "7",
        },
        {
          label: "退款成功关闭",
          value: "8",
        },
        {
          label: "退货订单",
          value: "9",
        },
        {
          label: "暂停/已付款但禁止发货",
          value: "10",
        },
      ],
      typeOptions: [
        {
          label: "普通",
          value: "0",
        },
        {
          label: "拼团",
          value: "1",
        },
        {
          label: "定金预售",
          value: "2",
        },
        {
          label: "订金找货",
          value: "3",
        },
        {
          label: "拍卖",
          value: "4",
        },
        {
          label: "0元单",
          value: "5",
        },
        {
          label: "回收",
          value: "6",
        },
        {
          label: "寄卖",
          value: "7",
        },
        {
          label: "寄样",
          value: "8",
        },
        {
          label: "0元抽奖(超级福袋)",
          value: "9",
        },
        {
          label: "达人买样",
          value: "10",
        },
        {
          label: "普通定制",
          value: "11",
        },
        {
          label: "大众竞拍",
          value: "12",
        },
        {
          label: "小时达",
          value: "13",
        },
        {
          label: "定金预售的赠品单",
          value: "14",
        },
        {
          label: "收款",
          value: "15",
        },
        {
          label: "一口价",
          value: "16",
        },
        {
          label: "一口价、拍卖",
          value: "17",
        },
        {
          label: "自动发货",
          value: "18",
        },
        {
          label: "旺店入门版交易",
          value: "19",
        },
        {
          label: "旺店标准版交易",
          value: "20",
        },
        {
          label: "直冲",
          value: "21",
        },
        {
          label: "货到付款",
          value: "22",
        },
        {
          label: "分销",
          value: "23",
        },
        {
          label: "游戏装备",
          value: "24",
        },
        {
          label: "ShopEX交易",
          value: "25",
        },
        {
          label: "万网交易",
          value: "26",
        },
        {
          label: "统一外部交易",
          value: "27",
        },
        {
          label: "O2O交易",
          value: "28",
        },
        {
          label: "万人团",
          value: "29",
        },
        {
          label: "无付款订单",
          value: "30",
        },
        {
          label: "预授权0元购机交易",
          value: "31",
        },
        {
          label: "京东自营订单",
          value: "32",
        },
        {
          label: "京东POP订单",
          value: "33",
        },
      ],
      payType: [
        {
          label: "货到付款",
          value: "1",
        },
        {
          label: "邮局汇款",
          value: "2",
        },
        {
          label: "自提",
          value: "3",
        },
        {
          label: "在线支付",
          value: "4",
        },
        {
          label: "公司转账",
          value: "5",
        },
        {
          label: "银行转账",
          value: "6",
        },
        {
          label: "微信",
          value: "7",
        },
        {
          label: "支付宝",
          value: "8",
        },
        {
          label: "小程序",
          value: "9",
        },
        {
          label: "余额",
          value: "10",
        },
        {
          label: "无需支付（0元单）",
          value: "11",
        },
        {
          label: "DOU分期（信用支付）",
          value: "12",
        },
        {
          label: "新卡支付",
          value: "13",
        },
        {
          label: "先用后付",
          value: "14",
        },
      ],
      shopList: [],
      orderSearch: {
        tid: "",
        statusList: [],
        channelSellerManageIdList: [],
      },
      tableData: [],
      tableInfo: [
        {
          label: "平台名称",
          prop: "platformName",
          width: 150,
        },
        {
          label: "店铺",
          prop: "companySellerName",
          width: 150,
        },
        {
          label: "主订单ID",
          prop: "tid",
          width: 150,
        },
        {
          label: "交易类型",
          prop: "type",
          slot: "type",
          width: 150,
        },
        {
          label: "交易状态（主）",
          prop: "status",
          slot: "status",
          width: 150,
        },
        {
          label: "订单总金额（元）",
          prop: "totalFee",
          width: 150,
        },
        {
          label: "实付金额（元）",
          prop: "receivedPayment",
          width: 150,
        },
        {
          label: "优惠金额（元）",
          prop: "discountFee",
          width: 150,
        },
        {
          label: "支付方式",
          prop: "payType",
          slot: "payType",
          width: 150,
        },
        {
          label: "是否使用购物金",
          prop: "isExpandCardAmount",
          slot: "isExpandCardAmount",
          width: 150,
        },
        {
          label: "购物金使用金额（元）",
          prop: "expandCardAmount",
          width: 150,
        },
        {
          label: "下单时间",
          prop: "orderStartTime",
          width: 150,
        },
        {
          label: "付款时间",
          prop: "orderPaymentTime",
          width: 150,
        },
        {
          label: "发货时间",
          prop: "deliveryTime",
          width: 150,
        },
      ],
      talbeLoading: false,
      memberId: "",
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      totalList: 0,
    };
  },
  computed: {
    platformList() {
      let list = this.$platformList;
      console.log(this.shopList);
      list = list.filter((item) => {
        return this.shopList.some((obj) => {
          return item.value == obj.platform;
        });
      });
      return list;
    },
  },
  created() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {},
  methods: {
    getLabel(val, arr) {
      const index = arr.findIndex((item) => item.value == val);
      if (index != -1) {
        return arr[index].label;
      } else {
        return "";
      }
    },
    getSearch(obj) {
      this.getOrderList();
    },
    //重置
    getClean() {
      this.orderSearch = {
        tid: "",
        statusList: [],
        channelSellerManageIdList: [],
      };
      this.getOrderList();
    },
    // 打开订单详情弹窗
    openDrawer(row) {
      this.memberId = row.memberId;
      this.getShopList();
      this.getSearch();
      this.isShowDrawer = true;
    },
    handleClose() {
      this.memberId = "";
      (this.pageInfo = {
        pageNum: 1,
        pageSize: 10,
      }),
        (this.totalList = 0);
      this.tableData = [];
      this.orderSearch = {
        tid: "",
        statusList: [],
        channelSellerManageIdList: [],
      };
      this.isShowDrawer = false;
    },
    // 获取选择店铺
    getShopList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      };
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.shopList = res.data.dataList;
        }
      });
    },
    handlePage(page) {
      this.pageInfo.pageNum = page.pageNum;
      this.pageInfo.pageSize = page.pageSize;
      this.getOrderList();
    },
    getOrderList() {
      this.talbeLoading = true;
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        hytMemberId: this.memberId,
        channelSellerManageIdList: this.orderSearch.channelSellerManageIdList,
        tid: this.orderSearch.tid,
        statusList: this.orderSearch.statusList,
        size: this.pageInfo.pageSize,
        current: this.pageInfo.pageNum,
      };
      console.log(_param);
      getOrderListReq(_param)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.totalList = res.data.pageInfo.total;
          }
        })
        .finally(() => {
          this.talbeLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order_details {
  .form_box {
    margin-bottom: 16px;
  }
}
</style>